import objectifyArray from 'objectify-array'
import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'

import {
    createAxiosInstance,
    uniqueArray
} from '../../utils/helpers'

export function obtenerParametros() {
    const axios = createAxiosInstance()
    return (dispatch) => {
        axios.get(`${API_URL}/parametros`)
            .then((res) => {
                const parametros = objectifyArray(res.data, {
                    by: ['id'],
                    recursive: true
                })
                const fn1 = d => d({
                    type: types.PARAMETROS_POBLAR_PARAMETROS,
                    payload: {
                        parametros
                    }
                })
                fn1(dispatch)
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function displayModalCreate(show, title, mode) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_DISPLAY_MODAL_CREACION,
            payload: {
                show,
                title,
                mode
            }
        })
    }
}

export function adicionarConfiguracion() {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_ADICIONAR_CONFIGURACION
        })
    }
}

export function adicionarDetalle() {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_ADICIONAR_DETALLE
        })
    }
}

export function eliminarConfiguracion() {
    return (dispatch, getState) => {
        let toDelete = getState().parameters.getIn(['modalCreate', 'data', 'configuraciones']).filter(x => x.get('selected') === true)
        const total = toDelete.count()
        toDelete = toDelete.filter(x => x.get('id') > 0)
        if (toDelete.count() > 0) {
            const axios = createAxiosInstance()
            const fns = []
            toDelete.map(x => x.get('id')).forEach(x => {
                const fn = () => axios.delete(`${API_URL}/parametros/configuracion/${x}`)
                fns.push(fn)
            })

            const toResultObject = (promise) => {
                return promise
                    .then(result => ({
                        success: true,
                        result
                    }))
                    .catch(error => ({
                        success: false,
                        error
                    }));
            }

            Promise.all(fns.map(x => x()).map(toResultObject))
                .then(res => {
                    const succeded = []
                    const failed = []
                    res.forEach(x => {
                        if (!x.success) {
                            failed.push(x.error.response.data.ExceptionMessage)
                            let url = x.error.config.url.split('/')
                            let configId = url[url.length - 1]
                            let index = getState().parameters.getIn(['modalCreate', 'data', 'configuracioneS']).findIndex(x => x.get('id') === Number(configId))
                            dispatch({
                                type: types.PARAMETROS_MODIFICAR_INPUTS,
                                payload: {
                                    path: `modalCreate.data.configuraciones.${index}.selected`,
                                    value: false
                                }
                            })
                        } else {
                            succeded.push(1)
                            dispatch({
                                type: types.PARAMETROS_ELIMINAR_CONFIGURACION,
                                payload: x.result.data.id
                            })
                        }
                    })
                    if (succeded.length > 0) displayMessages(dispatch, {
                        success: `Se han eliminado ${succeded.length + (total - toDelete.count())} de los ${total} registros`
                    })
                    if (failed.length > 0) displayMessages(dispatch, {
                        response: {
                            status: 500,
                            data: failed.join('\n')
                        }
                    })
                    dispatch({
                        type: types.PARAMETROS_ELIMINAR_CONFIGURACIONES
                    })
                })
        } else {
            dispatch({
                type: types.PARAMETROS_ELIMINAR_CONFIGURACIONES
            })
        }
    }
}

export function seleccionarParametro(id) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_SELECCIONAR_PARAMETRO,
            payload: id
        })
    }
}

export function almacenarParametro() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('parametros', true))
        let data = getState().parameters.getIn(['modalCreate', 'data'])
        const mode = getState().parameters.getIn(['modalCreate', 'mode'])

        const selects = ['tipo_dato', 'tipo_campo', 'lista_parametro_id', 'campo_lista_parametro']
        const trueFalse = ['unico']
        data.get('configuraciones').forEach((x, n) => {
            let v
            selects.forEach(s => {
                v = data.getIn(['configuraciones', String(n), s])
                if (String(v) === '-1') data = data.setIn(['configuraciones', String(n), s], null)
            })
            trueFalse.forEach(t => {
                v = String(data.getIn(['configuraciones', String(n), t])) === "true"
                data = data.setIn(['configuraciones', String(n), t], v ? true : false)
            })
        })

        if (mode === 'create') {
            axios.post(`${API_URL}/parametros`, data)
                .then(res => {
                    const id = res.data.id
                    const parametro = objectifyArray([res.data], {
                        by: ['id'],
                        recursive: true
                    })
                    dispatch({
                        type: types.PARAMETROS_ACTUALIZAR_PARAMETRO,
                        payload: parametro[id]
                    })
                    dispatch(displayModalCreate(false))
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, {
                        success: 'La parametro ha sido guardada exitosamente'
                    })
                })
                .catch(err => {
                    console.log(err)
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, err)
                })
        } else if (mode === 'edit') {
            axios.put(`${API_URL}/parametros/${data.get('id')}`, data)
                .then(res => {
                    const parametro = objectifyArray([res.data], {
                        by: ['id'],
                        recursive: true
                    })
                    dispatch({
                        type: types.PARAMETROS_ACTUALIZAR_PARAMETRO,
                        payload: parametro[data.get('id')]
                    })
                    dispatch(displayModalCreate(false))
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, {
                        success: 'La parametro ha sido guardada exitosamente'
                    })
                })
                .catch(err => {
                    console.log(err)
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, err)
                })
        }
    }
}

export function almacenarDetalles() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('parametros', true))
        const selected = getState().parameters.get('selected')
        let details = getState().parameters.getIn(['parametros', String(selected), 'data']).valueSeq()
        const configuraciones = getState().parameters.getIn(['parametros', String(selected), 'columnas'])
        let toStore = []
        details.forEach(a => {
            configuraciones.forEach(b => {
                let dt = a.get(String(b.get('id')))
                dt = dt.set('registro', a.get('registro'))
                if (a.getIn([String(b.get('id')), 'updated'])) toStore.push(dt)
            })
        })

        if (toStore.length > 0) {
            axios.put(`${API_URL}/parametros/detalles`, toStore)
                .then(res => {
                    const parametro = objectifyArray([res.data], {
                        by: ['id'],
                        recursive: true
                    })
                    dispatch({
                        type: types.PARAMETROS_ACTUALIZAR_PARAMETRO,
                        payload: parametro[selected]
                    })
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, {
                        success: 'La parametro ha sido guardada exitosamente'
                    })
                })
                .catch(err => {
                    console.log(err)
                    dispatch(setSavingState('parametros', false))
                    displayMessages(dispatch, err)
                })
        } else {
            dispatch(setSavingState('parametros', false))
        }
    }
}

export function resetAfterTipoCampo(path) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_MODIFICAR_INPUTS,
            payload: {
                path: `${path}.tipo_dato`,
                value: -1
            }
        })
        dispatch({
            type: types.PARAMETROS_MODIFICAR_INPUTS,
            payload: {
                path: `${path}.lista_parametro_id`,
                value: -1
            }
        })
        dispatch({
            type: types.PARAMETROS_MODIFICAR_INPUTS,
            payload: {
                path: `${path}.campo_lista_parametro`,
                value: -1
            }
        })
    }
}

export function marcarComoActualizado(path) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_MODIFICAR_INPUTS,
            payload: {
                path: `${path}.updated`,
                value: true
            }
        })
    }
}

export function eliminarDetalles() {
    return (dispatch, getState) => {
        const selected = getState().parameters.get('selected')
        let selectedDetails = getState().parameters.getIn(['parametros', String(selected), 'data']).valueSeq().filter(x => x.get('selected') === true)
        const configuraciones = getState().parameters.getIn(['parametros', String(selected), 'columnas'])
        let toDelete = []

        selectedDetails.forEach(a => {
            configuraciones.forEach(b => {
                let dt = a.get(String(b.get('id')))
                if (dt.get('id') > 0) toDelete.push(a.get('registro'))
            })
        })
        toDelete = uniqueArray(toDelete)

        const total = selectedDetails.count()
        if (toDelete.length > 0) {
            const axios = createAxiosInstance()
            const fns = []
            toDelete.forEach(x => {
                const fn = () => axios.delete(`${API_URL}/parametros/${selected}/detalles/${x}`)
                fns.push(fn)
            })

            const toResultObject = (promise) => {
                return promise
                    .then(result => ({
                        success: true,
                        result
                    }))
                    .catch(error => ({
                        success: false,
                        error
                    }));
            }

            Promise.all(fns.map(x => x()).map(toResultObject))
                .then(res => {
                    const succeded = []
                    const failed = []
                    res.forEach(x => {
                        if (!x.success) {
                            failed.push(x.error.response.data.ExceptionMessage)
                            let url = x.error.config.url.split('/')
                            let registro = url[url.length - 1]
                            dispatch({
                                type: types.PARAMETROS_MODIFICAR_INPUTS,
                                payload: {
                                    path: `parametros.${selected}.data.${registro}.selected`,
                                    value: false
                                }
                            })
                        } else {
                            succeded.push(1)
                            let url = x.result.config.url.split('/')
                            let registro = url[url.length - 1]
                            dispatch({
                                type: types.PARAMETROS_ELIMINAR_DETALLE,
                                payload: registro
                            })
                        }
                    })
                    if (succeded.length > 0) displayMessages(dispatch, {
                        success: `Se han eliminado ${succeded.length + (total - toDelete.length)} de los ${total} registros`
                    })
                    if (failed.length > 0) displayMessages(dispatch, {
                        response: {
                            status: 500,
                            data: failed.join('\n')
                        }
                    })
                    dispatch({
                        type: types.PARAMETROS_ELIMINAR_DETALLES
                    })
                })
        } else {
            dispatch({
                type: types.PARAMETROS_ELIMINAR_DETALLES
            })
        }
    }
}

export function eliminarParametros() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const selected = getState().parameters.get('selected')
        axios.delete(`${API_URL}/parametros/${selected}`)
            .then(res => {
                dispatch({
                    type: types.PARAMETROS_ELIMINAR_PARAMETROS,
                    payload: selected
                })
            })
            .catch(err => {
                displayMessages(dispatch, err)
            })
    }
}

export function toggleSelectAllItems(value) {
    return (dispatch, getState) => {
        const selected = getState().parameters.get('selected')
        getState().parameters.getIn(['parametros', String(selected), 'data']).keySeq().forEach(n => {
            const path = `parametros.${selected}.data.${n}.selected`
            dispatch({
                type: types.PARAMETROS_MODIFICAR_INPUTS,
                payload: {
                    path,
                    value
                }
            })
        })
    }
}

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_REINICIAR_ESTADO
        })
    }
}

export function filtrarParametros(termino) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_MODIFICAR_FILTRO,
            payload: termino
        })
    }
}

export function ordenarPor(columna) {
    return (dispatch) => {
        dispatch({
            type: types.PARAMETROS_ORDENAR_COLUMNA,
            payload: columna
        })
    }
}